import dayjs from 'dayjs';
import _ from 'lodash';

import { TEAM_CHAT_FALLBACK_MEMBER_NAME } from '../TeamChat.constants';
import { getMemberChatUserId, getMemberNickname } from '../TeamChat.utils';

import { UNKNOWN_INITIAL } from './TeamChatReadBy.constants';

export const getInitial = nickname =>
  nickname ? nickname.trim().charAt(0).toUpperCase() : UNKNOWN_INITIAL;

export const getReaders = ({ lastOwnMessageAt, members, readReceipts, currentChatUserId }) => {
  if (!lastOwnMessageAt) {
    return [];
  }

  const threshold = dayjs(lastOwnMessageAt).valueOf();

  return (members ?? [])
    .map(member => {
      const chatUserId = getMemberChatUserId(member);

      if (!chatUserId || chatUserId === currentChatUserId) {
        return null;
      }

      const readAt = readReceipts?.[chatUserId];

      if (!readAt || dayjs(readAt).valueOf() < threshold) {
        return null;
      }

      return {
        chatUserId,
        nickname: getMemberNickname(member) || TEAM_CHAT_FALLBACK_MEMBER_NAME,
        readAt,
      };
    })
    .filter(entry => !_.isNull(entry));
};
